import React from 'react';

// const Loading = () => <div className="spinner"></div>;

const Loading = () => <span className="lds-heart"><div></div></span>;

export default Loading;
